import React, { Component } from 'react';
import Logo2 from '../../assets/images/fallandi/Fallandi_logo_login.png'

import ModalVideo from 'react-modal-video'
import { Spinner, Button } from 'reactstrap';

class Videobox2 extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }

    openModal() {
        this.setState({ isOpen: true })
    }
    render() {
        return (

            <div className="row justify-content-center">
                <ModalVideo channel='youtube' isOpen={this.state.isOpen} autoplay={true} videoId='-dMt2KAQJ14' onClose={() => this.setState({ isOpen: false })} />
                <div className="col-12 col-lg-10">
                    <div className="flex flex-col gap-20 items-center sm:flex-row justify-center">
                        {/* Image */}
                        <img src={Logo2} className="" alt="logo" style={{ maxWidth: "200px" }} />
                        <div className="video-btn">
                            <a className="play-btn popup-youtube" onClick={this.openModal} ><i className="la la-play" /></a>
                            <div className="spinner-eff new-spinner-eff">
                                <div className="spinner-circle circle-1" />
                                <div className="spinner-circle circle-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

export default Videobox2;